import { Text, VStack } from "@chakra-ui/react";
import React, { Fragment } from "react";
import { Plan } from "./Plan";
import { PlanAccount } from "./PlanAccount";
import { ValueProps } from "./ValueProps";

export function StdPlanText({
  recommendedPlan,
  currentPlan,
  subtext,
  account,
}: {
  recommendedPlan: Plan;
  currentPlan: Plan | undefined;
  subtext: string;
  account: PlanAccount;
}) {
  return (
    <>
      <VStack align="start" spacing={0.5}>
        <Text fontWeight={"bold"}>Unlock {recommendedPlan.name} plan</Text>
        <Text>{subtext}</Text>
      </VStack>

      <ValueProps
        recommendedPlan={recommendedPlan}
        currentPlan={currentPlan}
        account={account}
      />
    </>
  );
}
